import {Button, Form, Input} from 'antd';

const formItems = [
	{name: 'username', placeholder: 'Full name', message: 'Please input your full name!'},
	{name: 'email', placeholder: 'Email address', message: 'Please input your email!'},
	{name: 'subject', placeholder: 'Subject', message: 'Please input your subject!'},
	{name: 'phone', placeholder: 'Phone number', message: 'Please input your phone!'},
	{name: 'text', placeholder: 'Company Name', message: 'Please input company name!'},
	{
		name: 'intro',
		placeholder: 'Your message',
		message: 'Please input your message!',
		isTextArea: true
	}
];

const FormrenderFormItems = () => {
	const [form] = Form.useForm();

	const renderFormItems = () =>
		formItems.map(item => (
			<Form.Item key={item.name} name={item.name} rules={[{required: true, message: item.message}]}>
				{item.isTextArea ? (
					<Input.TextArea placeholder={item.placeholder} />
				) : item.name === 'phone' ? (
					<Input placeholder={item.placeholder} />
				) : (
					<Input placeholder={item.placeholder} />
				)}
			</Form.Item>
		));

	return (
		<div className="swft-sistem-form">
			<Form
				form={form}
				name="contact-form"
				layout="vertical"
				initialValues={{remember: true}}
				onFinish={values => console.log(values)}
				onFinishFailed={errorInfo => console.log(errorInfo)}
				autoComplete="off">
				{renderFormItems()}
				<Form.Item>
					<Button type="primary" htmlType="submit" className="swft-sistem-form-submit">
						Contact
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default FormrenderFormItems;
